import { css } from 'linaria';
import { SpinnerProps } from './spinner';
import { Variables } from '../index';

export const root = css`
    fill: transparent;
    animation: loading 0.75s linear infinite forwards;

    @keyframes loading {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
`;

export const variants: Record<SpinnerProps['variant'], string> = {
    primary: css`
        color: ${Variables.css.spinnerPrimary};
    `,
    secondary: css`
        color: ${Variables.css.spinnerSecondary};
    `,
    muted: css`
        color: ${Variables.css.spinnerMuted};
    `,
};
